import * as React from "react";
import { Section } from "./Section.jsx";
import { TextCard } from "../frame/TextCard.jsx";
import { FormJSON } from "../form/FormJSON.jsx";
import { SchemaJSON } from "../form/SchemaJSON.js";
export * from "../frame/Action.js";
export { SectionFormJSON };
/**
 * Генератор простой формы-секции учебного продукта по схеме JSON.
 *
 * @summary Генератор формы-секции по схеме JSON.
 * @param {Object} props - Атрибуты элемента JSX.
 * @param {SchemaJSON} props.schema - Схема JSON. 
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../form/SchemaJSON.js}
 * @example 
 * <SectionFormJSON schema={schema}/>;
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function SectionFormJSON({ schema }) {
  schema = new SchemaJSON(schema);
  const title = schema.getTitle();
  const description = schema.getDescription();
  const widgetDescription = description ?
    <TextCard type="primary">{description}</TextCard> : null;
  return (
    <Section
      icon={schema.icon}
      title={title}>
      {widgetDescription}
      <FormJSON schema={schema} />
    </Section>
  );
}
